import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthForm } from '../components/auth/AuthForm';
import { useAuth } from '../contexts/AuthContext';

export default function SignIn() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if the user is coming from signup page (check both state and URL query param)
  const fromSignupState = location.state?.fromSignup === true;
  const searchParams = new URLSearchParams(location.search);
  const fromSignupUrl = searchParams.get('fromSignup') === 'true';
  const fromSignup = fromSignupState || fromSignupUrl;

  // Si déjà connecté, rediriger vers le dashboard
  useEffect(() => {
    if (user) {
      navigate('/app/dashboard');
    }
  }, [user, navigate]);

  // Vérifier si un plan est enregistré dans localStorage
  useEffect(() => {
    const selectedPlanString = localStorage.getItem('selectedPlan');
    if (selectedPlanString) {
      try {
        const selectedPlan = JSON.parse(selectedPlanString);
        // Si le plan date de plus d'une heure, on le supprime
        const now = Date.now();
        const timestamp = selectedPlan.timestamp || 0;
        const oneHour = 60 * 60 * 1000;
        if (now - timestamp > oneHour) {
          localStorage.removeItem('selectedPlan');
        }
      } catch (err) {
        console.error('Error parsing selected plan:', err);
        localStorage.removeItem('selectedPlan');
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">
            Sign in to your account
          </h2>
          {fromSignup && (
            <p className="mt-2 text-green-400">
              Account created successfully! Please sign in now.
            </p>
          )}
          <p className="mt-2 text-gray-400">
            Or{' '}
            <Link to="/signup" className="text-indigo-400 hover:text-indigo-300">
              create a new account
            </Link>
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl p-8 rounded-2xl border border-white/10">
          <AuthForm mode="signin" />
        </div>
      </div>
    </div>
  );
}